/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from "react";
import { Box } from "@mui/system";
import VideoRecorder from "react-video-recorder";
import {
  // RecordWebcam,
  useRecordWebcam,
  CAMERA_STATUS,
} from "react-record-webcam";
import { Button } from "@mui/material";
import ActionRecorderBtn from "./ActionRecorderBtn";
import TimeLineRecorder from "./TimeLineRecorder";
import HeaderRecorder from "./HeaderRecorder";
import { getPlayerState } from "../../../redux/features/playerSlice";
import CustomHelmet from "../CustomHelmet";
import { fetcherGetToken, fetcherPost } from "../../../services/fetcher";
import { getSettingState } from "../../../redux/features/settingSlice";

// const OPTIONS = {
//   filename: "test-filename",
//   fileType: "mp4",
//   width: 1080,
//   height: 1920,
//   recordingLength: 4,
// };

const AddPostPage = () => {
  // const recordWebcam = useRecordWebcam(OPTIONS);
  // const getRecordingFileHooks = async () => {
  //   const blob = await recordWebcam.getRecording();
  //   console.log({ blob });
  // };
  return (
    <>
      <CustomHelmet title={`Add a post | Recorder`} />
      <Box
        className='recorder'
        sx={{
          height: "100vh",
          // position: "relative",
          display: "flex",
          // justifyContent: "center",
          backgroundColor: "#212121",
        }}
      >
        <HeaderRecorder />
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
            // position: "fixed",
            display: "flex",
            justifyContent: "center",
            // top: 0,
            // right: 0,
            // left: 0,
            // height: 0,
          }}
        >
          <ActionRecorderBtn />

          {/* <Box sx={{ position: "absolute", bottom: "5px", width: "100%" }}>
            <TimeLineRecorder ref={ref} data={topicData} />
          </Box> */}
        </Box>
      </Box>
    </>
  );
};

export default AddPostPage;
